/**
 * Cylindo AR Link Component
 * For simple/finished products without 3D viewer
 * Displays a "See it in your space" link that opens AR experience via QR code
 *
 * Based on Cylindo Content API ARQR:
 * https://pdp.cylindo.com/API/content-api#arqr
 */

import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {
  Box, Button, Image, Modal, ModalBody, ModalCloseButton, ModalContent,
  ModalHeader, ModalOverlay, Text, useDisclosure, VStack,
} from '@salesforce/retail-react-app/app/components/shared/ui';

const CylindoARLink = ({
  arqrUrl,
  productName,
  buttonText = 'See it in your space',
}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();

  if (!arqrUrl) return null;

  return (
    <>
      {/* AR Link Button */}
      <Button
        colorScheme="blue"
        mt={4}
        size="lg"
        variant="outline"
        width="full"
        leftIcon={
          <Box as="span" fontSize="xl">
            📱
          </Box>
        }
        onClick={onOpen}
      >
        {buttonText}
      </Button>

      {/* QR Code Modal */}
      <Modal isOpen={isOpen} size="md" onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>View in Augmented Reality</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={4}>
              <Text textAlign="center">
                Scan this QR code with your mobile device to see {productName} in your space
              </Text>

              {/* QR Code Image */}
              <Box
                bg="white"
                borderRadius="md"
                boxShadow="md"
                p={4}
              >
                <Image
                  alt={`QR code to view ${productName} in AR`}
                  height="auto"
                  maxWidth="300px"
                  src={arqrUrl}
                  width="100%"
                />
              </Box>

              <Text color="gray.600" fontSize="sm" textAlign="center">
                Works on iOS and Android devices with AR support
              </Text>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

CylindoARLink.propTypes = {
  arqrUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  productName: PropTypes.string,
};

export default CylindoARLink;
